(() => {
  const formatYen = (cents) => `¥${new Intl.NumberFormat('ja-JP').format(Math.round(cents / 100))}`;

  document.addEventListener('change', (event) => {
    const fieldset = event.target.closest('[data-serio-addons]') || event.target.closest('form')?.querySelector('[data-serio-addons]');
    if (!fieldset) return;
    const form = fieldset.closest('form');
    const quantity = Math.max(1, Number(form?.querySelector('[name="quantity"]')?.value) || 1);
    const basePrice = Number(fieldset.dataset.basePriceCents) || 0;
    const addonPrice = [...fieldset.querySelectorAll('input[data-serio-addon-id]:checked')]
      .reduce((sum, input) => sum + (Number(input.dataset.priceCents) || 0), 0);
    fieldset.querySelector('[data-serio-total]').textContent = formatYen((basePrice + addonPrice) * quantity);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const fieldset = form.querySelector('[data-serio-addons]');
    if (!fieldset) return;
    const selected = [...fieldset.querySelectorAll('input[data-serio-addon-id]:checked')];
    if (selected.length === 0) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    const productForm = form.closest('product-form');
    const submitButton = form.querySelector('[type="submit"]');
    const bodyVariantId = Number(form.querySelector('[name="id"]')?.value);
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
    const bundleKey = `serio-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const items = [bodyVariantId, ...selected.map((input) => Number(input.dataset.serioAddonId))]
      .map((id) => ({ id, quantity, properties: { _serio_same_purchase: bundleKey } }));

    if (!bodyVariantId || items.some((item) => !item.id)) {
      productForm?.handleErrorMessage('商品を追加できませんでした。ページを再読込してお試しください。');
      return;
    }

    submitButton.disabled = true;
    productForm?.handleErrorMessage();
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'カートに追加できませんでした。');
      window.location.assign(window.routes?.cart_url || `${window.Shopify.routes.root}cart`);
    } catch (error) {
      productForm?.handleErrorMessage(error.message || 'カートに追加できませんでした。');
      submitButton.disabled = false;
    }
  }, true);
})();
